var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { BASE_BORDER_WIDTH, createUIElement, SPACING_M, SPACING_XXXL } from "../../helpers";
import { VIEW_BORDER } from "../../View";
import { PageHeader } from "../../PageHeader";
import { Spacer } from "../../layouts";
import { PageHeaderSeparator } from "../../PageHeader/PageHeader";
export var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n    height: ", ";\n    box-sizing: border-box;\n    border-bottom: ", " solid\n        ", ";\n"], ["\n    padding-left: ", ";\n    padding-right: ", ";\n    height: ", ";\n    box-sizing: border-box;\n    border-bottom: ", " solid\n        ", ";\n"])), SPACING_M, SPACING_M, SPACING_XXXL, BASE_BORDER_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.borders[VIEW_BORDER.normal];
});
export var PageWizardHeader = createUIElement('PageWizardHeader', function (_a, ref) {
    var className = _a.className, _b = _a.hasBack, hasBack = _b === void 0 ? false : _b, _c = _a.disabledBack, disabledBack = _c === void 0 ? false : _c, title = _a.title, description = _a.description, rightAddon = _a.rightAddon, onBackClick = _a.onBackClick, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "hasBack", "disabledBack", "title", "description", "rightAddon", "onBackClick", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(Root, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'pagewizard-wizardheader', className: "vm-PageWizardHeader " + className, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(PageHeader, { hasBack: hasBack, disabledBack: disabledBack, onBackClick: onBackClick, title: title, secondaryText: description, content: rightAddon && (React.createElement(React.Fragment, null,
                React.createElement(Spacer, null),
                React.createElement(PageHeaderSeparator, null),
                rightAddon)) })));
});
var templateObject_1;
//# sourceMappingURL=PageWizardHeader.js.map